import React, { useState } from 'react';
import { Container, Form, Header, Icon, Breadcrumb, Button, Grid, Placeholder, Segment, Message } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { useHistory, useLocation } from 'react-router';
import { useBookESPForm } from './useBookESPForm';
import moment from 'moment';

export function BookESPForm() {

    let [values, masterData, errors, touched, isLoading, isSubmitting, isValid, submitSuccess, errorMessage, registerRef, handleChange, handleBlur, handleSubmit, handleDownloadCalendar] = useBookESPForm();

    const history = useHistory();
    console.log(masterData);
    return <Container className='providers-container'>
        <Header as='h1' style={{ marginTop: '2.0rem', marginBottom: '0.5rem' }}>Book Your Employer Spotlight Presentation Spot</Header>
        <hr style={{ marginBottom: '1.0rem' }} />
        <Breadcrumb style={{ marginBottom: '1.0rem' }}>
            <Breadcrumb.Section link><Link to='/'>Home</Link></Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section link><Link to={'/employerSpotlightPresentation'}>Employer Spotlight Presentation</Link></Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section active>Book Employer Spotlight Presentation Spot</Breadcrumb.Section>
        </Breadcrumb>

        <Segment basic style={{ padding: 0 }}>
            <Grid columns={1}>
                {
                    !masterData &&
                    <Grid.Column>
                        <Placeholder fluid>
                            <Placeholder.Paragraph>
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                                <Placeholder.Line />
                            </Placeholder.Paragraph>
                        </Placeholder>
                    </Grid.Column>
                }
                {
                    masterData &&
                    <Grid.Column>
                        <Header as='h2' attached='top' inverted className='ESP-list'>
                            {masterData.organization + ' - ' + masterData.topic}
                        </Header>
                        <Segment attached>
                            <p dangerouslySetInnerHTML={{ __html: (masterData.description || '').replaceAll('\n', "<br />\r\n") }}>
                            </p>
                            <Grid columns={2}>
                                <Grid.Row style={{paddingTop:'0.5rem', paddingBottom: '0.25rem'}}>
                                    <Grid.Column mobile={16} tablet={4} computer={2}>Date</Grid.Column>
                                    <Grid.Column mobile={16} tablet={12} computer={14}>{moment(masterData.startTime).format('dddd, MMM D, YYYY - hh:mm A')}{masterData.endTime ? ' to ' + moment(masterData.endTime).format('hh:mm A') : ''}</Grid.Column>
                                </Grid.Row>
                                <Grid.Row style={{paddingTop:'0.25rem', paddingBottom: '0.5rem'}}>
                                    <Grid.Column mobile={16} tablet={4} computer={2}>Location</Grid.Column>
                                    {
                                        masterData.presentationModeCode !== 'OL' && masterData.location &&
                                        <Grid.Column mobile={16} tablet={12} computer={14}><p dangerouslySetInnerHTML={{ __html: (masterData.location || '').replaceAll('\n', "<br />\r\n") }}></p></Grid.Column>
                                    }
                                    {
                                        masterData.presentationModeCode === 'OL' &&
                                        <Grid.Column mobile={16} tablet={12} computer={14}><span>Online</span></Grid.Column>
                                    }
                                </Grid.Row>
                            </Grid>
                        </Segment>
                    </Grid.Column>
                }
            </Grid>
        </Segment>
        <Grid columns={2} style={submitSuccess ? { margin: 0 } : {}}>
            {
                !submitSuccess &&
                <Grid.Column>
                    <Form loading={isSubmitting}>
                        <Form.Input className={!(!errors.firstName || !touched.firstName) ? 'mb-0' : ''}
                            required
                            fluid
                            label='First Name'
                            onChange={(event, data) => {
                                handleChange(data.value, 'firstName');
                            }}
                            onBlur={
                                () => { handleBlur('firstName') }
                            }
                            error={!(!errors.firstName || !touched.firstName) ? true : false}
                        />
                        {
                            !(!errors.firstName || !touched.firstName) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.firstName}</div>
                        }
                        <Form.Input className={!(!errors.lastName || !touched.lastName) ? 'mb-0' : ''}
                            required
                            fluid
                            label='Last Name'
                            onChange={(event, data) => {
                                handleChange(data.value, 'lastName');
                            }}
                            onBlur={
                                () => { handleBlur('lastName') }
                            }
                            error={!(!errors.lastName || !touched.lastName) ? true : false}
                        />
                        {
                            !(!errors.lastName || !touched.lastName) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.lastName}</div>
                        }
                        <Form.Input className={!(!errors.phoneNumber || !touched.phoneNumber) ? 'mb-0' : ''}

                            fluid
                            label='Phone Number'
                            onChange={(event, data) => {
                                handleChange(data.value, 'phoneNumber');
                            }}
                            onBlur={
                                () => { handleBlur('phoneNumber') }
                            }
                            error={!(!errors.phoneNumber || !touched.phoneNumber) ? true : false}
                        />
                        {
                            !(!errors.phoneNumber || !touched.phoneNumber) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.phoneNumber}</div>
                        }
                        <Form.Input className={!(!errors.email || !touched.email) ? 'mb-0' : ''}
                            required
                            fluid
                            label='Email Address'
                            onChange={(event, data) => {
                                handleChange(data.value, 'email');
                            }}
                            onBlur={
                                () => { handleBlur('email') }
                            }
                            error={!(!errors.email || !touched.email) ? true : false}
                        />
                        {
                            !(!errors.email || !touched.email) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.email}</div>
                        }
                        <Form.Input className={!(!errors.confirmEmail || !touched.confirmEmail) ? 'mb-0' : ''}
                            required
                            fluid
                            label='Confirm Email Address'
                            onChange={(event, data) => {
                                handleChange(data.value, 'confirmEmail');
                            }}
                            onBlur={
                                () => { handleBlur('confirmEmail') }
                            }
                            error={!(!errors.confirmEmail || !touched.confirmEmail) ? true : false}
                        />
                        {
                            !(!errors.confirmEmail || !touched.confirmEmail) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.confirmEmail}</div>
                        }

                        <Button type='button' loading={isSubmitting} primary onClick={handleSubmit}>Submit</Button>
                        <Button type='button' onClick={() => { history.goBack() }}>Cancel</Button>
                    </Form>
                </Grid.Column>
            }
            {
                submitSuccess &&
                <Message icon positive>
                    <Icon name='check circle outline' color='green' />
                    <Message.Content>
                        <Message.Header>Success</Message.Header>
                        <div>Thank you for registering. A confirmation email has been sent to you and the participant.</div>
                        <div style={{ marginTop: '0.5rem' }}>
                            <Button title='Download Calendar File for the event' icon labelPosition='left' size='small' onClick={handleDownloadCalendar}>
                                <Icon name='download' />
                                <span>Download Calendar File <Icon name='calendar alternate' /></span>
                            </Button></div>
                    </Message.Content>
                </Message>
            }

        </Grid>

    </Container>
}